
export const API_BASE = process.env.REACT_APP_API_BASE ?? "";
export const API_BASE_TUYENDUNG = API_BASE;
